import React, { useCallback, useEffect, useState } from 'react';
import { SubpageHeader } from '../components/SubpageHeader';
import { VentureGate } from '../components/venture/VentureGate';
import { EditorialOpening } from '../components/venture/editorial/EditorialOpening';
import { EditorialSpread } from '../components/venture/editorial/EditorialSpread';
import { CinemaQuote } from '../components/venture/editorial/CinemaQuote';
import { GatheringsIndex } from '../components/venture/editorial/GatheringsIndex';
import { HorizontalReel } from '../components/venture/editorial/HorizontalReel';
import { VelarisClosing } from '../components/velaris/VelarisClosing';
import { AmbientParticles } from '../components/venture/editorial/AmbientParticles';
import { ventureSpreads } from '../data/ventureStory';
import { useSmoothScroll } from '../hooks/useSmoothScroll';
type GateState = 'open' | 'leaving' | 'closed';
export function Velaris() {
  const [gate, setGate] = useState<GateState>('open');
  const contentReady = gate !== 'open';
  const onLeave = useCallback(() => setGate('leaving'), []);
  const onDone = useCallback(() => setGate('closed'), []);
  // Scrolling unlocks only once the gate has fully faded and any leftover
  // wheel/trackpad momentum has died down, so the story always starts at its top
  const [scrollReady, setScrollReady] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Venturist — The Venturist Club by Superluxury';
  }, []);
  useEffect(() => {
    if (gate === 'open') return;
    const root = document.documentElement;
    if (gate === 'leaving') {
      window.scrollTo(0, 0);
      root.style.overflow = 'hidden';
      return;
    }
    // Closed: pin to the top, then unlock after a short settle
    window.scrollTo(0, 0);
    const t = window.setTimeout(() => {
      window.scrollTo(0, 0);
      root.style.overflow = '';
      setScrollReady(true);
    }, 350);
    return () => window.clearTimeout(t);
  }, [gate]);

  // Never leave the page locked when navigating away
  useEffect(() => () => void (document.documentElement.style.overflow = ''), []);
  useSmoothScroll(scrollReady);
  const [first, second, ...rest] = ventureSpreads;
  return <div className="min-h-screen bg-ink text-paper" data-id="element-1608" data-mp="q8sa1rt8w7ot">
      {gate !== 'closed' && <VentureGate onLeave={onLeave} onDone={onDone} data-id="element-1609" data-mp="la8ldjn9ohsr" />}
      {contentReady && <>
          <SubpageHeader tone="dark" overlay data-id="element-1610" data-mp="3tqacfjq90mhu" />
          <AmbientParticles data-id="element-1611" data-mp="3tr3bdyiyu7pf" />
          <main data-id="element-1612" data-mp="3to7dga74bj0z">
            <EditorialOpening data-id="element-1613" data-mp="3orqstpz4nmsn" />
            <EditorialSpread spread={first} data-id="element-1614" data-mp="3osifucensc7b" />
            <EditorialSpread spread={second} data-id="element-1615" data-mp="3opmesf7il7en" />
            <CinemaQuote data-id="element-1616" data-mp="7c0rjklj1wlt" />
            {rest.map(spread => <EditorialSpread key={spread.index} spread={spread} data-id="element-1617" data-mp="2kirqzv8q22f" />)}
            <HorizontalReel data-id="element-1618" data-mp="2ifrzo4acuki" />
            <GatheringsIndex data-id="element-1619" data-mp="3aziwfzbr9xuh" />
            <VelarisClosing data-id="element-1620" data-mp="3ayrbdifsbiig" />
          </main>
        </>}
    </div>;
}